module.exports = __webpack_public_path__ + "img/star.e0585de9.svg";